"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.F = exports.L = void 0;
var reconnect_js_1 = require("reconnect.js");
var tw = __importStar(require("./tw"));
function L(key, defaultValue) {
  var appActions = reconnect_js_1.getOutlet('actions').getValue();
  if (appActions.L) {
    return appActions.L(key, defaultValue);
  } else if (defaultValue) {
    return defaultValue;
  }
  return tw.labels[key];
}
exports.L = L;
function F(obj, field) {
  if (!obj) {
    return '';
  }
  var defaultValue = obj[field];
  var appActions = reconnect_js_1.getOutlet('actions').getValue();
  if (appActions.F) {
    return appActions.F(obj, field);
  } else if (defaultValue) {
    return defaultValue;
  }
  return defaultValue;
}
exports.F = F;